import { INavmenuCollection } from "@/base/NewselaGlobalLayoutV2/NavigationBar/NavigationBar.provider";
import { COLLECTIONS_SLUGS } from "@/base/NewselaGlobalLayoutV2/NavigationBar/shared/constants";
import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import {
  Collection,
  getCollectionPathname,
} from "@/utils/collections/collections.constants";

export const hasCollectionPathNameParams = (collection: Collection) =>
  collection?.subject && collection?.root_text_set?.id;

export const getCustomCollectionsWithHref = (
  collections: Collection[],
): INavmenuCollection[] =>
  collections
    .filter(
      (collection) =>
        hasCollectionPathNameParams(collection) && collection.is_custom,
    )
    .map((customCollection) => ({
      ...customCollection,
      href: `${MONOLITH_ORIGIN}${getCollectionPathname(customCollection) || ""}`,
    }));

export const getPersonalizedCollectionsWithHref = (
  collections: Collection[],
): INavmenuCollection[] =>
  collections
    .filter((collection) => COLLECTIONS_SLUGS.includes(collection.slug))
    .map((personalizedCollection) => ({
      ...personalizedCollection,
      href: `${MONOLITH_ORIGIN}${getCollectionPathname(personalizedCollection) || ""}`,
    }));
